var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('database-picker',{attrs:{"rules":_vm.rules,"action":_vm.action,"return-id":_vm.returnId,"label":"Takip Mahiyet Tipi","item-text":"isim","default-first":"","cache-active":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }